import HM from './hook-manager';

// Filters:
//  * `wakefly/breakpoints` - Passes the default breakpoint list for modification

class Globals {
  get breakpoints() {
    var breakpoints = {
      'xs': 0,
      'sm': 480,
      'md': 768,
      'lg': 1024,
      'xl': 1366,
      'xxl': 1700
    };
    breakpoints = HM.do_filter('wakefly/breakpoints', breakpoints);

    return breakpoints;
  }
}

export default new Globals();
